import React from 'react';

import {
  Box,
  InputLabel as BaseInputLabel,
  styled
} from '@mui/material';



const InputLabel = styled(BaseInputLabel, {
  shouldForwardProp: prop => prop !== 'isDisabled'
})<{isDisabled?: boolean}>(({ isDisabled }) => ({
  color: '#486C82',
  opacity: isDisabled ? 0.38 : 1,
  fontSize: 12
}));



interface IProps {
  text: string;
  isDisabled?: boolean;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Box style={{ display: 'flex' }}>
      <InputLabel isDisabled={props.isDisabled}>
        {props.text}
      </InputLabel>
      <InputLabel
        style={{ color: '#E16B50' }}
        isDisabled={props.isDisabled}>
          &nbsp;*
      </InputLabel>
    </Box>
  );
};
